<template>
	<div class="vendors-info app-region blank-t-v blank-b-v blank-l-h blank-r-h">
		<!-- <a-form-model class="app-form" ref="form" :model="form" :rules="rules" :labelCol="$formLabelCol"
			:wrapperCol="$formWrapperCol"> -->
			<a-form-model class="app-form" ref="form" :model="form"  :labelCol="$formLabelCol" :wrapperCol="$formWrapperCol">

			<!-- 这里需要注意一下form中的数据，需要与参数对应 -->
			<a-form-model-item label="厂商类型" prop="type">
				<a-radio-group v-model="form.type">
					<a-radio :value="1">生产商</a-radio>
					<a-radio :value="2">维保商</a-radio>
				</a-radio-group>
			</a-form-model-item>

			<a-form-model-item label="厂商名称" prop="name">
				<a-input v-model="form.name" placeholder="请输入厂商名称" allow-clear></a-input>
			</a-form-model-item>

			<a-form-model-item label="厂商地址" prop="address">
				<a-input v-model="form.address" placeholder="请输入厂商地址" allow-clear></a-input>
			</a-form-model-item>

			<a-form-model-item label="联系人" prop="contacts">
				<a-input v-model="form.contacts" placeholder="请输入厂商联系人" allow-clear></a-input>
			</a-form-model-item>

			<a-form-model-item label="联系电话" prop="mobile">
				<a-input v-model="form.mobile" placeholder="请输入联系电话" allow-clear></a-input>
			</a-form-model-item>

			<a-form-model-item label="营业执照" prop="permit_image">
				<a-upload v-model="form.permit_image" name="media" :show-upload-list="false" list-type="picture-card"
					:action="$uploadUrl" class="app-avatar-uploader" :before-upload="$beforeUpload"
					@change="handleChange">
					<dy-image :src="form.permit_image" v-if="form.permit_image" preview></dy-image>
					<a-icon :type="avatar.loading ? 'loading' : 'plus'" v-else></a-icon>
				</a-upload>
			</a-form-model-item>

			<a-form-model-item :wrapper-col="$formEmptyLabelWrapperCol">
				<a-space>
					<a-button type="primary" @click="submit">确认提交</a-button>
					<a-button @click="cancel">取消</a-button>
				</a-space>
			</a-form-model-item>
		</a-form-model>


	</div>

</template>

<script>
	import Vendors from "@/io/vendors.js";

	export default {
		data() {
			return {

				// 从父页面传来的id
				id: this.$route.params.id,
				avatar: {
					loading: false,
				},
				form: {
					type: 1,
					name: null,
					address: null,
					contacts: null,
					mobile: null,
					permit_image: null,
				},
				// rules: {
				// 	name: [{
				// 		required: true,
				// 		message: "请输入厂商名称",
				// 	}, ],
				// 	address: [{
				// 		required: true,
				// 		message: "请输入厂商地址",
				// 	}],
				// 	contacts: [{
				// 		required: true,
				// 		message: "请输入联系人",
				// 	}, ],
				// 	mobile: [{
				// 		required: true,
				// 		message: "请输入联系电话",
				// 	}, ],
				// 	permit_image: [{
				// 		required: true,
				// 		message: "请上传营业执照",
				// 	}, ],


				// },
			}
		},

		mounted() {
			if (this.id) {
				this.initPage()
			}

		},

		methods: {


			handleChange(info) {
				let status = info.file.status;
				if (status) {
					if (status === 'done') {
						this.avatar.loading = false;
						this.form.permit_image = info.file.response.media;
					} else {
						this.avatar.loading = true;
					}
				}
			},
			// 获取上页数据
			initPage() {
				Vendors.info(this.id).then(res => {
					this.form.type = res.type
					this.form.name = res.name
					this.form.address = res.address
					this.form.contacts = res.contacts
					this.form.mobile = res.mobile
					this.form.permit_image = res.permit_image
				}).catch(err => {})
			},
			// 必须按照顺序写
			submit() {
				// this.$beforeFormSubmit(this.$refs.form, () => {
					if (this.id) {
						Vendors.edit(
							this.id,
							this.form.type,
							this.form.name,
							this.form.address,
							this.form.contacts,
							this.form.mobile,
							this.form.permit_image,

						).then((res) => {

							this.$afterFormSubmit('编辑成功', () => {
								this.cancel();
							});
						}).catch((err) => {});
					} else {
						Vendors.add(
							this.form.type,
							this.form.name,
							this.form.address,
							this.form.contacts,
							this.form.mobile,
							this.form.permit_image,

						).then((res) => {
							this.$afterFormSubmit('创建成功', () => {
								this.cancel();
							});
						}).catch((err) => {});
					}
				// });
			},

			cancel() {
				this.$router.push({
					name: 'VendorManage'
				});
			},
		},
	};
</script>

<style lang="less" scoped>

</style>
